/** @format */

export interface Addon {
  sku: string;
  qty: number;
  type: string;
}

export interface CartAddOn {
  warranty: CartWarranty;
}

interface CartWarranty {
  sku: number;
  qty: number;
}
